import { useEffect } from 'react';

import { transformChatData } from 'applications/GSP/pages/ParentHelper/utils';
import { useLazyGetApiParentHelperChatsByChatIdQuery } from 'applications/GSP/shared/api/gsp';

import { useGreetingMessages } from './hooks';

import type {
  ChatId,
  Message,
  SetChatId,
} from 'applications/GSP/pages/ParentHelper/types';
import type { Dispatch, SetStateAction } from 'react';

interface UseGetChatHistory {
  chatId: ChatId;
  setChatId: SetChatId;
  setData: Dispatch<SetStateAction<Message[]>>;
  setShouldScrollToBottom: Dispatch<SetStateAction<boolean>>;
}

export const useGetChatHistory = ({
  setData,
  chatId,
  setChatId,
  setShouldScrollToBottom,
}: UseGetChatHistory) => {
  const [getChatById, { isLoading, isFetching, isError: isErrorChat }] =
    useLazyGetApiParentHelperChatsByChatIdQuery();

  const greetingMessages = useGreetingMessages();

  useEffect(() => {
    if (!chatId) {
      setData(greetingMessages);

      return;
    }

    getChatById({ chatId })
      .unwrap()
      .then(({ messages, chatId: responseChatId }) => {
        setShouldScrollToBottom(true);

        const transformedMessages: Message[] = [...messages].reverse();

        const transformedChatData = transformChatData(transformedMessages);

        if (chatId !== responseChatId) {
          setChatId(responseChatId);
        }

        setData([...greetingMessages, ...transformedChatData]);
      })
      .catch(error => error);
  }, [
    chatId,
    greetingMessages,
    getChatById,
    setChatId,
    setData,
    setShouldScrollToBottom,
  ]);

  return {
    isLoadingChat: isLoading || isFetching,
    isErrorChat,
  };
};
